function getCookie(name) {
  var arr,
    reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)');

  if ((arr = document.cookie.match(reg))) return unescape(arr[2]);
  else return '';
}

/**
 * 上报日志
 * @param {Number} logID 数据打点ID
 * @param {Object} options 上报的数据
 * @param {Function} callback 成功的回调
 */
export function reportLog(logID, options = {}, callback) {
  let logImg = new Image();
  callback = callback || function() {};

  const logURL =
    process.env.NODE_ENV === 'production'
      ? process.env.VUE_APP_REALEASE === 'test'
        ? 'http://120.24.64.132:8080/miniworld'
        : 'https://tj2.mini1.cn/miniworld'
      : 'http://120.24.64.132:8080/miniworld';

  options = Object.assign(
    {},
    {
      _t: new Date().getTime(),
      v1: getCookie('uin'),
      v2: getCookie('apiid'),
      v3: getCookie('version'),
      v4: getCookie('country'),
      v5: getCookie('lang'),
      v6: 2,
      v7: '__IP__'
    },
    options
  );

  logImg.onload = function() {
    callback();
    logImg = null;
  };

  logImg.onerror = function(e) {
    callback(e);
    logImg = null;
  };

  const logParams = new URLSearchParams(options).toString();

  logImg.src = `${logURL}?k=${logID}&${logParams}`;
}
